<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";

export default defineComponent({
    name: "DeliveryAndShippingPage",
    components: {
        IconPaymentSbp,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentVisa,
        IconPaymentMaestro,
        Breadcrumbs,
        MobileTopBar,
    },
    data() {
        return {
            tariffs: [
                {weight: 'до 10 м²', price: '2 500 ₽'},
                {weight: 'до 1 тонны', price: '2 900 ₽'},
                {weight: '1 – 1,5 тонны', price: '3 700 ₽'},
                {weight: '1,5 – 2 тонны', price: '4 700 ₽'},
                {weight: 'от 2 тонн', price: 'Индивидуальный расчет', long: true},
                {weight: 'Доставка в нерабочее время', price: '+1 000 ₽'},
            ],
        };
    },
})
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="text-2xl md:text-3xl font-semibold mb-6">
            Информация о доставке, подъеме и самовывозе
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10 mb-5 md:mb-10">
            <div class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
                <h2 class="text-xl md:text-2xl font-semibold mb-4">Способы оплаты</h2>
                <p class="mb-4">
                    Оплатить заказ можно одним из следующих способов:
                </p>
                <ul class="list-disc list-outside ps-5 space-y-2">
                    <li>Наличными при визите в офис.</li>
                    <li>Наличными курьеру после осмотра и приема заказа.</li>
                    <li>Банковской картой в офисе или через интернет.</li>
                    <li>Безналичный расчет (с НДС и без НДС).</li>
                </ul>
            </div>
            <div class="bg-grayBg rounded-3xl px-5 md:px-8 py-8">
                <h2 class="text-xl md:text-2xl font-semibold mb-4">Онлайн-оплата картой</h2>
                <p class="mb-4">
                    Чтобы оплатить картой онлайн, оформите заказ на сайте или позвоните нам и сообщите менеджеру о
                    желании безналичной оплаты. Менеджер сформирует счет и вышлет ссылку для платежа на ваш e‑mail или в
                    WhatsApp.
                </p>
                <div class="flex items-center space-x-4">
                    <IconPaymentVisa class="h-12 w-auto"/>
                    <IconPaymentMir class="h-12 w-auto"/>
                    <IconPaymentMaestro class="h-12 w-auto"/>
                    <IconPaymentMasterCard class="h-12 w-auto"/>
                    <IconPaymentSbp class="h-12 w-auto"/>
                </div>
            </div>
        </div>
        <div
            class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10 mb-5 md:mb-10 bg-grayBg rounded-3xl px-5 md:px-8 py-8">
            <div>
                <h2 class="text-xl md:text-2xl font-semibold mb-4">Доставка по Москве и МО</h2>
                <p class="mb-3">
                    Как правило, доставка по Москве и области выполняется на следующий день после подтверждения заказа,
                    в некоторых случаях — в течение 2–3 дней.
                </p>
                <p class="mb-3">
                    Если вес заказа превышает 2,5 тонны, стоимость рассчитывается индивидуально, исходя из веса и
                    удаленности пункта доставки.
                </p>
                <p class="mb-3 text-orange-500 font-medium">
                    <span class="font-bold">
                        ВНИМАНИЕ:
                    </span>
                    Курьер доставляет груз до входа в здание. Разгрузку и подъем организовывает заказчик самостоятельно.
                    Возможность подъема нашими специалистами уточняйте у менеджера.
                </p>
                <p class="mb-3">
                    Первоначальные 30 минут разгрузки предоставляются бесплатно. Каждые последующие 30 минут
                    оплачиваются по 300 ₽.
                </p>
                <p class="mb-3">
                    Если клиент отказывается от товара при доставке, услуги доставки и подъема полагается оплатить
                    полностью.
                </p>
            </div>
            <div>
                <!-- Карточки тарифов -->
                <div class="grid grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5 mb-4">
                    <div v-for="(item, idx) in tariffs" :key="idx"
                         class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg min-h-[140px]">
                        <div class="font-bold text-sm text-gray-600">{{ item.weight }}</div>
                        <div
                            class="mt-2 font-semibold whitespace-pre-line break-words"
                            :class="item.long ? 'text-sm md:text-base leading-tight' : 'text-2xl'">
                            {{ item.price }}
                        </div>
                    </div>
                </div>
                <!-- Примечание -->
                <p class="text-sm text-gray-600">
                    Тарифы действуют внутри МКАД. За каждый километр за МКАД взимается доплата 50 ₽/км.
                </p>
            </div>
        </div>
        <!-- Разгрузка и подъём -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10 mb-5 md:mb-10">
            <div class="grid grid-cols-1 gap-5 md:gap-10">
                <div class="bg-grayBg rounded-3xl px-5 md:px-8 py-8 h-min">
                    <h2 class="text-xl md:text-2xl font-semibold mb-4">Услуга разгрузки и подъема</h2>
                    <p class="mb-3">
                        Мы предоставляем услугу разгрузки с заносом на этаж по предварительному заказу.
                    </p>
                    <ul class="list-disc list-inside space-y-2 mb-4">
                        <li>При отсутствии лифта стоимость указывается за каждый этаж.</li>
                        <li>Если кабина лифта находится между этажами, применяется надбавка 20%.</li>
                        <li>Когда подъезд недоступен ближе чем на 10 м, каждые дополнительные 10 м приравниваются к
                            одному этажу.
                        </li>
                        <li>Подача плитки из машины силами ваших грузчиков оплачивается отдельно по согласованию.</li>
                    </ul>
                </div>
                <div class="bg-grayBg rounded-3xl px-5 md:px-8 py-8 h-min">
                    <h2 class="text-xl md:text-2xl font-semibold mb-4">
                        Самовывоз из магазина
                    </h2>
                    <p class="mb-4">
                        Самовывоз доступен при наличии товара на складе. Пожалуйста, уточняйте наличие у менеджера.
                    </p>
                    <p class="mb-4">
                        Для небольших заказов доступна возможность самовывоза из шоурума на Каширском шоссе. Сроки
                        перемещения вашего заказа уточняйте у менеджера (обычно 2-5 дней). Стоимость перемещения заказа
                        в шоурум для самовывоза - 1000 руб.
                    </p>
                    <p class="mb-2 font-medium">Самовывоз из шоурума:</p>
                    <ul class="list-disc list-inside space-y-2">
                        <li>Доставка товара в шоурум занимает 2–5 рабочих дней.</li>
                        <li>Стоимость перемещения в шоурум составляет 1 000 ₽.</li>
                    </ul>
                </div>
            </div>
            <div class="bg-grayBg rounded-3xl h-min py-8">
                <div class="overflow-x-auto mb-4">
                    <div class="px-5 md:px-8">
                        <h2 class="text-xl md:text-2xl font-semibold mb-4">Тарифы на подъем с работающим лифтом</h2>
                    </div>
                    <div class="px-0 md:px-8">
                        <table class="min-w-full md:bg-white shadow md:rounded-lg overflow-hidden">
                            <thead class="md:bg-white">
                            <tr>
                                <th class="py-3 px-6 text-left">Услуга</th>
                                <th class="py-3 px-6 text-left">Стоимость</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="border-t">
                                <td class="py-3 px-6">Плитка мелкого формата (15×15, 20×20, 30×30, 40×40, 20×50, 30×60,
                                    25×75)
                                </td>
                                <td class="py-3 px-6 text-nowrap">100 ₽/м²</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Плитка среднего формата (60×60, 30×90, 20×120)</td>
                                <td class="py-3 px-6 text-nowrap">150 ₽/м²</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Плитка среднего формата (60×120, 75×75, 80×80)</td>
                                <td class="py-3 px-6 text-nowrap">200 ₽/м²</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Плитка крупного формата (90×90, 100×100, 120×120, 20×140, 75×150,
                                    80×160, 90×180)
                                </td>
                                <td class="py-3 px-6 text-nowrap">250 ₽/м²</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Плитка сверхкрупного формата (100×300, 120×240, 120×260, 120×270,
                                    120×280, 150×300, 160×320)
                                </td>
                                <td class="py-3 px-6 text-nowrap">900 ₽/м²</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Упаковка клея для плитки</td>
                                <td class="py-3 px-6 text-nowrap">200 ₽/пачку</td>
                            </tr>
                            <tr class="border-t">
                                <td class="py-3 px-6">Затирочная смесь</td>
                                <td class="py-3 px-6 text-nowrap">40 ₽/банку</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="px-5 md:px-8">
                    <p class="text-sm text-gray-600">
                        Цены указаны при наличии работающего лифта. В случае его отсутствия или других нюансов свяжитесь
                        с менеджером.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Дополнительные стили при необходимости */
</style>
